// istanbul ignore file
import * as getModBUsDataService from '../services/getModbusParamterService'
import { ModBusListDataLoadingAction, ModBusListDataUpdateAction, ModBusListDataErrorAction } from './getModbusParamterslice'
import * as getFlameSignalDataService from '../services/getFlameSignaGraphDataService'
import * as getFlameSignalDataServiceNew from '../services/getFlameSignaGraphDataServiceNew'
import * as getFlameSignaGraphKPIData from '../services/getFlameSignaGraphKPIDataService'
import { flameSignalDataLoadingAction, flameSignalDataUpdateAction, flameSignalDataErrorAction } from './getFlameSignaGraphDataSlice'
import { flameSignalDataLoadingActionNew, flameSignalDataUpdateActionNew, flameSignalDataErrorActionNew } from './getFlameSignaGraphDataSliceNew'
import { flameSignalKPIDataLoadingAction, flameSignalKPIDataUpdateAction, flameSignalKPIDataErrorAction } from './getFlameSignaGraphKPIDataSlice'
import { flowSignalParamDataLoadingAction, flowSignalParamDataUpdateAction, flowSignalParamDataErrorAction } from './getFlowSignaGraphParamDataSlice'
import { flowSignalKPIDataLoadingAction, flowSignalKPIDataUpdateAction, flowSignalKPIDataErrorAction } from './getFlowSignaGraphKPIDataSlice'
import { getFlameSignalDataOptions } from '../components/ChartOptions'
import * as getStanderdandCustomService from '../services/getStandardandCustomParamterService'
import { StandardandCustomListDataLoadingAction, StandardandCustomListDataUpdateAction, StandardandCustomListDataErrorAction } from './getStandardandCustomParamterSlice'
import { DeviceDetailsListLoadingAction, DeviceDetailsListUpdateAction, DeviceDetailsListErrorAction } from './getDeviceListSlice'
import * as getDevicelistService from '../services/getDeviceListService'
import { type kpiDefinitionIdsRequest } from '../services/getStandardandCustomParamterService'
import { type ModBusParameter1, type ModBusParameter2, type ModBusParameter3, type ModBusParameter4 } from '../services/getFlameSignaGraphDataService'
import { DeviceStatusLoadingAction, DeviceStatusUpdateAction, DeviceStatusErrorAction } from './getDeviceStatusListSlice'
import * as getDeviceStatusService from '../services/getDeviceStatusService'
import { AlertsCountDetailsLoadingAction, AlertsCountDetailsUpdateAction, AlertsCountDetailsErrorAction } from './getAlertCountSlice'
import * as getAlertCountDetails from '../services/getalertCountService'
import { SaveDefaultViewDataLoadingAction, SaveDefaultViewDataUpdateAction, SaveDefaultViewDataErrorAction, SaveDefaultViewDataReset } from './saveDefaultViewSlice'
import * as saveDefaultView from '../services/saveDeafultViewService'
import * as getAlertNotification from '../services/getNotificationByFilter'
import { AlertsNotificationDataLoadingAction, AlertsNotificationDataUpdateAction, AlertsNotificationDataErrorAction } from './getNotificationByFilterSlice'
import * as clearNotiicationService from '../services/clearNotificationService'
import { ClearNotificationLoadingAction, ClearNotificationUpdateAction, ClearNotificationErrorAction } from './clearNotificationServiceSlice'
import * as acknowledgeNotificationService from '../services/acknowledgeNotification'
import { AcknowledgeNotificationLoadingAction, AcknowledgeNotificationUpdateAction, AcknowledgeNotificationErrorAction } from './acknowledgeNotificationServiceSlice'
import * as deviceOnlineStatusService from '../services/getDeviceStatusOnlineService'
import { DeviceStatusOnlineLoadingAction, DeviceStatusOnlineUpdateAction, DeviceStatusOnlineErrorAction } from './getDeviceStatusOnlineSlice'
import * as exportGraphDataService from '../services/exportGraphDataService'
import * as exportGraphKPIDataService from '../services/exportGraphKPIDataService'
import { exportDeviceDataGraphLoadingAction, exportDeviceDataGraphUpdateAction, exportDeviceDataGraphErrorAction } from './exportGraphSlice'
import { exportDeviceKPIDataGraphLoadingAction, exportDeviceKPIDataGraphUpdateAction, exportDeviceKPIDataGraphErrorAction } from './exportGraphKPIDataSlice'
import * as healthSummaryService from '../services/getHealthSummaryService'
import { healthSummaryLoadingAction, healthSummaryUpdateAction, healthSummaryErrorAction } from './getHealthSummarySlice'
import * as DeviceStatusSummary from '../services/getDeviceStatusSummaryService'
import { deviceRegisterStatusSummayLoadingAction, deviceRegisterStatusSummayUpdateAction, deviceRegisterStatusSummayErrorAction } from './getDeviceStatusSummaryRegisterSlice'
import { deviceKPIStatusSummayLoadingAction, deviceKPIStatusSummayUpdateAction, deviceKPIStatusSummayErrorAction } from './getDeviceStatusSummaryKPISlice'
import * as defaultViewService from '../services/getSaveDefaultViewService'
import { GetSaveDefaultWidgeLoadingAction, GetSaveDefaultWidgeUpdateAction, GetSaveDefaultWidgeErrorAction } from './getSaveDefaultViewServiceSlice'
import * as getAlertTrendRegisterDataDeviceDashboard from '../services/getAlertTredRegisterData'
import { AlertTrendRegisterDataDeviceLoadingAction, AlertTrendRegisterDataDeviceUpdateAction, AlertTrendRegisterDataDeviceErrorAction } from './getAlertTredRegisterDataSlice'
import * as getAlertTrendKPIDataDeviceDashboard from '../services/getAlertTrendKPIDataDeviceDashboard'
import { AlertTrendKPIDataDeviceLoadingAction, AlertTrendKPIDataDeviceUpdateAction, AlertTrendKPIDataDeviceErrorAction } from './getAlertTredKPIDataDeviceDashboardSlice'
import moment from 'moment-timezone'
import * as ParameterConfigurations from '../../../features/services/services/parameterConfigurations'

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

export const getModbusListDetails = (assetId: string, assetTypeId: string) => async (dispatch: any) => {
  dispatch(ModBusListDataLoadingAction())
  try {
    await getModBUsDataService.getModbuParamterData(assetId, assetTypeId, (ModBusParameterListData, httpStatus) => {
      dispatch(ModBusListDataUpdateAction({ data: ModBusParameterListData.assetRegisterData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(ModBusListDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(ModBusListDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getSaveDeafaultWidget = (siteId: string, parentAssetId: string, assetId: string) => async (dispatch: any) => {
  dispatch(GetSaveDefaultWidgeLoadingAction())
  try {
    await defaultViewService.getSaveDefaultViewService(assetId, async (DefaultWidgetData, httpStatus) => {
      // For Filtering deleted or disabled KPI's, Modbus Parameters, Custom KPI's
      await ParameterConfigurations.fetchParameterConfigurations(siteId, parentAssetId, (response, status) => {
        const filteredDefaultView = DefaultWidgetData?.assetDashBoardDefaultView?.assetDashBoardDefaultView?.map((e: any) => {
          return {
            ...e,
            assets: e?.assets?.filter((a: any) => a?.kpidefinitionIds?.filter((k: any) => response?.data?.assetKPIs?.map((ak: any) => ak.kpiDefinitionId)?.includes(k))?.length > 0),
            devices: e?.devices?.map((d: any) => {
              const device = response?.data?.gateway?.[0]?.device?.filter((rd: any) => rd.id === d?.deviceId)?.[0]
              const cimCodeIds = d?.cimCodeIds?.filter((f: any) => device?.registers?.map((c: any) => c.cimCodeId)?.includes(f))
              const kpidefinitionIds = d?.kpidefinitionIds?.filter((f: any) => device?.kpis?.map((c: any) => c.kpiDefinitionId)?.includes(f))
              return {
                ...d,
                cimCodeIds,
                kpidefinitionIds
              }
            })?.filter((d: any) => [...d.cimCodeIds, ...d.kpidefinitionIds]?.length > 0)
          }
        })
        dispatch(GetSaveDefaultWidgeUpdateAction({ data: { assetDashBoardDefaultView: filteredDefaultView }, httpStatus }))
      }, () => {
        dispatch(GetSaveDefaultWidgeUpdateAction({ data: DefaultWidgetData?.assetDashBoardDefaultView, httpStatus }))
      })
    },
    (errorMessage, httpStatus) => {
      dispatch(GetSaveDefaultWidgeErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(GetSaveDefaultWidgeErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getStandardandCustomListDetails = (page: number, size: number, pagination: boolean, latest: boolean, kpiDefinitionIds: kpiDefinitionIdsRequest) => async (dispatch: any) => {
  dispatch(StandardandCustomListDataLoadingAction())
  try {
    await getStanderdandCustomService.getStandardandCustomParamter(page, size, pagination, latest, kpiDefinitionIds, (StandardandCustomListData, httpStatus) => {
      dispatch(StandardandCustomListDataUpdateAction({ data: StandardandCustomListData.content, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(StandardandCustomListDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(StandardandCustomListDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

interface ChartData {
  readingTime: string
  indexValue: number
  value: number
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const parseChartSeriesData = (data: ChartData[]): Array<[number, number, number]> => {
  if (!Array.isArray(data) || data.length === 0) {
    return []
  }
  const acc: Array<[number, number, number]> = [] // Initialize an empty accumulator array
  data.forEach(arrElem => {
    const readingDate = moment.utc(arrElem.readingTime).tz(userTimezone).valueOf()
    acc.push([readingDate, arrElem.indexValue, arrElem.value]) // Use push
  })
  return acc // Return the populated accumulator array
}

export const fetchflameSignalData = (assetId: string, cimCodeID: string, startDateTime: string, endDateTime: string, graphName: string) => (dispatch: any) => {
  dispatch(flameSignalDataLoadingAction())
  void getFlameSignalDataService.getFlameSignaGraphData(
    assetId,
    cimCodeID,
    startDateTime,
    endDateTime,
    graphName,
    (ModBusParameter1: ModBusParameter1, ModBusParameter2: ModBusParameter2, ModBusParameter3: ModBusParameter3, ModBusParameter4: ModBusParameter4, httpStatus) => {
      const parsedModBusParameter1 = parseChartSeriesData(
        (ModBusParameter1[0]?.assetIntervalReadingsData ?? [])
          .filter(
            (item: any) =>
              item.readingTime !== null &&
              item.indexValue !== null &&
              item.value !== null
          )
          .map(
            (item: any) => ({
              readingTime: item.readingTime as string,
              indexValue: item.indexValue as number,
              value: item.value as number
            })
          )
      )
      const parsedModBusParameter2 = parseChartSeriesData(
        (ModBusParameter2[0]?.assetIntervalReadingsData ?? [])
          .filter(
            (item: any) =>
              item.readingTime !== null &&
              item.indexValue !== null &&
              item.value !== null
          )
          .map(
            (item: any) => ({
              readingTime: item.readingTime as string,
              indexValue: item.indexValue as number,
              value: item.value as number
            })
          )
      )
      const parsedModBusParameter3 = parseChartSeriesData(
        (ModBusParameter3[0]?.assetIntervalReadingsData ?? [])
          .filter(
            (item: any) =>
              item.readingTime !== null &&
              item.indexValue !== null &&
              item.value !== null
          )
          .map(
            (item: any) => ({
              readingTime: item.readingTime as string,
              indexValue: item.indexValue as number,
              value: item.value as number
            })
          )
      )
      const parsedModBusParameter4 = parseChartSeriesData(
        (ModBusParameter4[0]?.assetIntervalReadingsData ?? [])
          .filter(
            (item: any) =>
              item.readingTime !== null &&
              item.indexValue !== null &&
              item.value !== null
          )
          .map(
            (item: any) => ({
              readingTime: item.readingTime as string,
              indexValue: item.indexValue as number,
              value: item.value as number
            })
          )
      )

      const units = [
        ModBusParameter1[0]?.units,
        ModBusParameter2[0]?.units,
        ModBusParameter3[0]?.units,
        ModBusParameter4[0]?.units
      ]

      const registerNames = [
        ModBusParameter1[0]?.registerName,
        ModBusParameter2[0]?.registerName,
        ModBusParameter3[0]?.registerName,
        ModBusParameter4[0]?.registerName
      ]

      // Using the spread operator to pass the parameters as needed and ensure the function supports multiple inputs.
      const chartArrayData = getFlameSignalDataOptions(
        ...[parsedModBusParameter1, parsedModBusParameter2, parsedModBusParameter3, parsedModBusParameter4].map((param, index) =>
          [param, units[index], registerNames[index]]
        ).flat()
      )

      const channelDataOptions = {
        flameSignalChartOptions: chartArrayData
      }

      const flameSignalDataOptions = { flameSignalChartOptions: channelDataOptions }

      dispatch(flameSignalDataUpdateAction({ data: flameSignalDataOptions.flameSignalChartOptions, httpStatus }))
    },
    // Error handling
    (errorMessage, httpStatus) => {
      dispatch(flameSignalDataErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const getDeviceListDetails = (siteId: string, assetId: string) => async (dispatch: any) => {
  dispatch(DeviceDetailsListLoadingAction())
  try {
    await getDevicelistService.getDeviceListData(siteId, assetId, (DeviceListData, httpStatus) => {
      dispatch(DeviceDetailsListUpdateAction({ data: DeviceListData.devices, total_count: DeviceListData.total_count, httpStatus }))
    },
    // istanbul ignore next
    (errorMessage, httpStatus) => {
      dispatch(DeviceDetailsListErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(DeviceDetailsListErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getDeviceStatusListDetails = (assetId: string, assetTypeId: string, cimCodeIDs: string) => async (dispatch: any) => {
  dispatch(DeviceStatusLoadingAction())
  try {
    await getDeviceStatusService.getDeviceStatusData(assetId, assetTypeId, cimCodeIDs, (DeviceStatusListData, httpStatus) => {
      dispatch(DeviceStatusUpdateAction({ data: DeviceStatusListData.assetRegisterData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(DeviceStatusErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(DeviceStatusErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getAlertsCountDetailsData = (deviceId: string) => async (dispatch: any) => {
  dispatch(AlertsCountDetailsLoadingAction())
  try {
    await getAlertCountDetails.getAlertCountDetails(deviceId, (AlertsCountDetailsData, httpStatus) => {
      dispatch(AlertsCountDetailsUpdateAction({ data: AlertsCountDetailsData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(AlertsCountDetailsErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(AlertsCountDetailsErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const saveDefaultViewDataservice = (deviceId: string, requestParameter: any) => async (dispatch: any) => {
  dispatch(SaveDefaultViewDataLoadingAction())
  try {
    await saveDefaultView.SaveDefaultViewService(deviceId, requestParameter, (SaveDefaultViewData, httpStatus) => {
      dispatch(SaveDefaultViewDataUpdateAction({ data: SaveDefaultViewData.data, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(SaveDefaultViewDataErrorAction({ errorMessage, httpStatus }))
    },
    () => {
      dispatch(SaveDefaultViewDataReset())
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(SaveDefaultViewDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getAlertsNotificationDataByFilter = (siteId: string, assetId: string, deviceId: string, severities: string, alertStatus: string, alarmLabelIds: string, sortOrder: string) => async (dispatch: any) => {
  dispatch(AlertsNotificationDataLoadingAction())
  try {
    await getAlertNotification.getNotificationByFilter(siteId, assetId, deviceId, severities, alertStatus, alarmLabelIds, sortOrder, (AlertsNotificationData, httpStatus) => {
      dispatch(AlertsNotificationDataUpdateAction({ data: AlertsNotificationData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(AlertsNotificationDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(AlertsNotificationDataErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getclearNotiicationService = (deviceId: string) => async (dispatch: any) => {
  dispatch(ClearNotificationLoadingAction())
  try {
    await clearNotiicationService.clearNotificationService(deviceId, (clearNotificationDetails, httpStatus) => {
      dispatch(ClearNotificationUpdateAction({ data: clearNotificationDetails, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(ClearNotificationErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(ClearNotificationErrorAction({ errorMessage: e.response?.message, httpStatus: e.response.status }))
  }
}

export const getacknowledgeNotificationService = (deviceId: string) => async (dispatch: any) => {
  dispatch(AcknowledgeNotificationLoadingAction())
  try {
    await acknowledgeNotificationService.acknowledgeNotificationService(deviceId, (ACKNotificationDetails, httpStatus) => {
      dispatch(AcknowledgeNotificationUpdateAction({ data: ACKNotificationDetails, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(AcknowledgeNotificationErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(AcknowledgeNotificationErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getDeviceStatusOnlineService = (deviceId: string) => async (dispatch: any) => {
  dispatch(DeviceStatusOnlineLoadingAction())
  try {
    await deviceOnlineStatusService.getDeviceStatusOnlineService(deviceId, (DeviceStatusOnlineData, httpStatus) => {
      dispatch(DeviceStatusOnlineUpdateAction({ data: DeviceStatusOnlineData, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(DeviceStatusOnlineErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(DeviceStatusOnlineErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getExportGraphDataService = (startDateTime: string, endDateTime: string, request: string, type: string) => async (dispatch: any) => {
  dispatch(exportDeviceDataGraphLoadingAction())
  try {
    await exportGraphDataService.exportGraphDataService(
      startDateTime,
      endDateTime,
      request,
      type,
      (message: any) => {
        dispatch(exportDeviceDataGraphUpdateAction(message))
      },
      (errorMessage: any) => {
        dispatch(exportDeviceDataGraphErrorAction(errorMessage))
      })
  } catch (e: any) {
    dispatch(exportDeviceDataGraphErrorAction(e))
  }
}

export const getExportGraphKPIDataService = (startDateTime: string, endDateTime: string, request: string, type: string) => async (dispatch: any) => {
  dispatch(exportDeviceKPIDataGraphLoadingAction())
  try {
    await exportGraphKPIDataService.exportGraphKPIDataService(
      startDateTime,
      endDateTime,
      request,
      type,
      (message: any) => {
        dispatch(exportDeviceKPIDataGraphUpdateAction(message))
      },
      (errorMessage: any) => {
        dispatch(exportDeviceKPIDataGraphErrorAction(errorMessage))
      })
  } catch (e: any) {
    dispatch(exportDeviceKPIDataGraphErrorAction(e))
  }
}

export const getHealthSummaryService = (siteId: string, asseIds: string, deviceIds: string) => async (dispatch: any) => {
  dispatch(healthSummaryLoadingAction())
  try {
    healthSummaryService.fetchAlamHealthSummary(siteId, asseIds, deviceIds, (data: any, httpStatus: number) => {
      dispatch(healthSummaryUpdateAction({ data, httpStatus }))
    },
    (errorMessage: any, httpStatus: number) => {
      dispatch(healthSummaryErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    dispatch(healthSummaryErrorAction(e))
  }
}

export const getDeviceStatusRegisterSummaryService = (siteId: string, deviceIds: string, cimCodeIDs: string, isDefault: boolean) => async (dispatch: any) => {
  dispatch(deviceRegisterStatusSummayLoadingAction())
  try {
    DeviceStatusSummary.fetchDeviceStatusRegisterSummary(siteId, deviceIds, cimCodeIDs, isDefault, (data: any, httpStatus: number) => {
      dispatch(deviceRegisterStatusSummayUpdateAction({ data, httpStatus }))
    },
    (errorMessage: any, httpStatus: number) => {
      dispatch(deviceRegisterStatusSummayErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    dispatch(deviceRegisterStatusSummayErrorAction(e))
  }
}

export const getDeviceStatusKPISummaryService = (siteId: string, deviceIds: string, kpiDefinitionIds: string, isDefault: boolean) => async (dispatch: any) => {
  dispatch(deviceKPIStatusSummayLoadingAction())
  try {
    DeviceStatusSummary.fetchDeviceStatusKPISummary(siteId, deviceIds, kpiDefinitionIds, isDefault, (data: any, httpStatus: number) => {
      dispatch(deviceKPIStatusSummayUpdateAction({ data, httpStatus }))
    },
    (errorMessage: any, httpStatus: number) => {
      dispatch(deviceKPIStatusSummayErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    dispatch(deviceKPIStatusSummayErrorAction(e))
  }
}

export const getAlertTrendRegisterDataDeviceDashboardService = (startDate: string, endDate: string, requestParameter: any, intervalGroup: string, isdefault: boolean, timeZone: string) => async (dispatch: any) => {
  dispatch(AlertTrendRegisterDataDeviceLoadingAction())
  try {
    await getAlertTrendRegisterDataDeviceDashboard.getAlertTrendRegisterDataDeviceDashboard(startDate, endDate, requestParameter, intervalGroup, isdefault, timeZone, (AlertTrendRegisterDataDeviceDashboard, httpStatus) => {
      dispatch(AlertTrendRegisterDataDeviceUpdateAction({ data: AlertTrendRegisterDataDeviceDashboard, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(AlertTrendRegisterDataDeviceErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(AlertTrendRegisterDataDeviceErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const getAlertTrendKPIDataDeviceDashboardService = (startDate: string, endDate: string, requestParameter: any, intervalGroup: string, isdefault: boolean, timeZone: string) => async (dispatch: any) => {
  dispatch(AlertTrendKPIDataDeviceLoadingAction())
  try {
    await getAlertTrendKPIDataDeviceDashboard.getAlertTrendKPIDataDeviceDashboard(startDate, endDate, requestParameter, intervalGroup, isdefault, timeZone, (AlertTrendKPIDataDeviceDashboard, httpStatus) => {
      dispatch(AlertTrendKPIDataDeviceUpdateAction({ data: AlertTrendKPIDataDeviceDashboard, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      // istanbul ignore next
      dispatch(AlertTrendKPIDataDeviceErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    // istanbul ignore next
    dispatch(AlertTrendKPIDataDeviceErrorAction({ errorMessage: e.response.message, httpStatus: e.response.status }))
  }
}

export const fetchflameSignalDataNEWONE = (startDateTime: string, endDateTime: string, request: string, isDefault: boolean) => async (dispatch: any) => {
  dispatch(flameSignalDataLoadingActionNew())
  try {
    await getFlameSignalDataServiceNew.getFlameSignaGraphData(startDateTime, endDateTime, request, isDefault, (data: any, httpStatus: number) => {
      dispatch(flameSignalDataUpdateActionNew({ data, httpStatus }))
    },
    (errorMessage: any, httpStatus: number) => {
      dispatch(flameSignalDataErrorActionNew({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    dispatch(flameSignalDataErrorActionNew(e))
  }
}

export const fetchflameKPISignalData = (startDateTime: string, endDateTime: string, request: string, isDefault: boolean) => async (dispatch: any) => {
  dispatch(flameSignalKPIDataLoadingAction())
  try {
    await getFlameSignaGraphKPIData.getFlameSignaGraphKPIData(startDateTime, endDateTime, request, isDefault, (data: any, httpStatus: number) => {
      // Filter out data points with execution_status === "Failure"
      const filteredData = data.map((device: any) => ({
        ...device,
        assetIntervalReading: device.assetIntervalReading.map((reading: any) => ({
          ...reading,
          assetIntervalReadingData: reading.assetIntervalReadingData.filter(
            (dataPoint: any) => dataPoint.execution_status !== 'Failure'
          )
        }))
      }))
      dispatch(flameSignalKPIDataUpdateAction({ data: filteredData, httpStatus }))
    },
    (errorMessage: any, httpStatus: number) => {
      dispatch(flameSignalKPIDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    dispatch(flameSignalKPIDataErrorAction(e))
  }
}

export const fetchflowParamSignalData = (startDateTime: string, endDateTime: string, request: string, isDefault: boolean) => async (dispatch: any) => {
  dispatch(flowSignalParamDataLoadingAction())
  try {
    await getFlameSignalDataServiceNew.getFlameSignaGraphData(startDateTime, endDateTime, request, isDefault, (data: any, httpStatus: number) => {
      dispatch(flowSignalParamDataUpdateAction({ data, httpStatus }))
    },
    (errorMessage: any, httpStatus: number) => {
      dispatch(flowSignalParamDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    dispatch(flowSignalParamDataErrorAction(e))
  }
}

export const fetchflowKPISignalData = (startDateTime: string, endDateTime: string, request: string, isDefault: boolean) => async (dispatch: any) => {
  dispatch(flowSignalKPIDataLoadingAction())
  try {
    await getFlameSignaGraphKPIData.getFlameSignaGraphKPIData(startDateTime, endDateTime, request, isDefault, (data: any, httpStatus: number) => {
      // Filter out data points with execution_status === "Failure"
      const filteredData = data.map((device: any) => ({
        ...device,
        assetIntervalReading: device.assetIntervalReading.map((reading: any) => ({
          ...reading,
          assetIntervalReadingData: reading.assetIntervalReadingData.filter(
            (dataPoint: any) => dataPoint.execution_status !== 'Failure'
          )
        }))
      }))
      dispatch(flowSignalKPIDataUpdateAction({ data: filteredData, httpStatus }))
    },
    (errorMessage: any, httpStatus: number) => {
      dispatch(flowSignalKPIDataErrorAction({ errorMessage, httpStatus }))
    })
  } catch (e: any) {
    dispatch(flowSignalKPIDataErrorAction(e))
  }
}
